import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { assertNever } from 'owa-assert';
import { FileProviderType } from './constants';
import { isFeatureEnabled } from 'owa-feature-flags';

// returns whether a fileprovider is enabled throughout OWA
export default function isFileProviderEnabled(provider: FileProviderType): boolean {
    const configuration = getUserConfiguration();
    switch (provider) {
        case AttachmentDataProviderType.GDrive:
            return (
                configuration.AttachmentPolicy.GoogleDriveAttachmentsEnabled &&
                configuration.AttachmentPolicy.ThirdPartyAttachmentsEnabled &&
                isFeatureEnabled('doc-fileProvider-gdrive')
            );
        case AttachmentDataProviderType.Mailbox:
        case AttachmentDataProviderType.OneDrivePro:
            return true;
        case AttachmentDataProviderType.Box:
            return (
                configuration.AttachmentPolicy.BoxAttachmentsEnabled &&
                configuration.AttachmentPolicy.ThirdPartyAttachmentsEnabled &&
                isFeatureEnabled('doc-fileProvider-box')
            );
        case AttachmentDataProviderType.Dropbox:
            return (
                configuration.AttachmentPolicy.DropboxAttachmentsEnabled &&
                configuration.AttachmentPolicy.ThirdPartyAttachmentsEnabled &&
                isFeatureEnabled('doc-fileProvider-dropbox')
            );
        case AttachmentDataProviderType.Facebook:
            return (
                configuration.AttachmentPolicy.ThirdPartyAttachmentsEnabled &&
                isFeatureEnabled('doc-fileProvider-facebook')
            );
        case AttachmentDataProviderType.OneDriveConsumer:
            if (isConsumer()) {
                // If its a consumer account then OneDriveConsumer
                // would always be enabled
                return true;
            }

            return (
                isFeatureEnabled('doc-filePicker-oneDriveConsumerForO365') &&
                configuration.AttachmentPolicy.OnedriveAttachmentsEnabled &&
                configuration.AttachmentPolicy.ThirdPartyAttachmentsEnabled
            );
        case AttachmentDataProviderType.MailMessage:
            return isFeatureEnabled('doc-filePicker-mailMessageAttachment');
        case AttachmentDataProviderType.WopiBox:
        case AttachmentDataProviderType.WopiEgnyte:
        case AttachmentDataProviderType.WopiDropbox:
            return (
                configuration.AttachmentPolicy.ThirdPartyAttachmentsEnabled &&
                isFeatureEnabled('doc-fileProvider-wopiClient')
            );
        default:
            return assertNever(provider);
    }
}
